import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=311991af&scoped=true&"
import script from "./AvatarCard.vue?vue&type=script&lang=ts&"
export * from "./AvatarCard.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarCard.vue?vue&type=style&index=0&id=311991af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311991af",
  null
  
)

export default component.exports